"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LicenseService = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var index_1 = require("../services/index");
var LicenseService = /** @class */ (function () {
    function LicenseService() {
        this.__priority = 100;
        this.hasNoLicense = false;
    }
    LicenseService.prototype.init = function () {
        var _this = this;
        (0, mobx_1.reaction)(function () { return index_1.Services.Department.current; }, function () { return _this.hasNoLicense = false; });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], LicenseService.prototype, "hasNoLicense", void 0);
    return LicenseService;
}());
exports.LicenseService = LicenseService;
//# sourceMappingURL=license.service.js.map